import moment from 'moment';
import config from 'config';
import chain from '@ersinfotech/chain';
import _ from 'lodash';
import request from 'helpers/superagent';
import {fetchFeedSuccess, fetchFeedFail, fetchQueryFail, fetchQuerySuccess} from './actions';

const fragment = `
  ... on News {
    globalId
    mediaType
    date
    title
    content
    from
    in
    images
    words
    score
    sentiment
    isTraditional
    url
  }
  ... on Print {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    downloadUrl
    url
  }
  ... on Youtube {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Pixnet{
    globalId
    id
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    comments
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Forum {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    hotvalue
    position
    words
    score
    url
  }
  ... on Weibo {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    shares
    score
    url
    createdAt
    updatedAt
  }
  ... on ForumComment {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    position
    words
  }
  ... on Blog {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    score
    url
  }
  ... on Video {
    globalId
    mediaType
    date
    title
    content
    from
    in
    words
    score
    url
    videoUrl
  }
  ... on Macautalk {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    words
    score
  }
  ... on Facebook {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    fromId
    by
    likes
    comments
    shares
    hotvalue
    words
    score
    statusType
    source
    url
    picture
    fullPicture
    images
  }
  ... on Wechat {
    globalId
    mediaType
    date
    title
    content
    from
    by
    images
    hits
    likes
    words
    score
    url
  }
  ... on Twitter {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    by
    images
    likes
    shares
    words
    score
    url
    profileImageUrl
  }
  ... on Goods {
    globalId
    mediaType
    title
    content
    from
    in
    images
    averageScore
    price
    comments
    words
    score
    url
  }
  ... on Page {
    globalId
    id
    mediaType
    title
    content
    data
    from
    in
    by
    comments
    words
    score
    url
  }
  ... on Instagram {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    byImageUrl
    images
    hits
    comments
    likes
    words
    url
  }
`;

export const fetchFeed = (query = {}) => {
  const {access_token} = localStorage;
  return request.post(`${config.edata.baseUrl}/graphql`)
    .query({
      access_token,
    })
    .send({
      query: `
        query(
          $limit: Int
          $offset: Int
          $globalId: [String]
          $mediaType: [MediaTypeEnum]
          $q: [String]
          $not: [String]
          $startDate: String
          $endDate: String
          $sourceGroupName: [String]
          $sourceGroupId: [String]
          $sourceGroupLabel: String
          $source: [SourceInput]
          $from: [String]
          $in: [String]
          $by: [String]
          $subjectId: String
          $sort: SortEnum
          $order: OrderEnum
          $isHighlight: Boolean
          $isCustomSort: Boolean
          $startSentiment: Float
          $endSentiment: Float
        ) {
          search(
            limit: $limit
            offset: $offset
            globalId: $globalId
            mediaType: $mediaType
            q: $q
            not: $not
            startDate: $startDate
            endDate: $endDate
            sourceGroupName: $sourceGroupName
            sourceGroupId: $sourceGroupId
            sourceGroupLabel: $sourceGroupLabel
            source: $source
            from: $from
            in: $in
            by: $by
            subjectId: $subjectId
            sort: $sort
            order: $order
            isCustomSort: $isCustomSort
            startSentiment: $startSentiment
            endSentiment: $endSentiment
            isHighlight: $isHighlight
          ) {
            count
            took
            data {
              ${fragment}
            }
          }
        }
      `,
      variables: {
        ...query.query,
        isHighlight: _.get(query, 'query.isHighlight', true)
      },
    })
    .endAsync()
    .get('body')
    .then(body => {
      const data = body.data.search;
      return fetchFeedSuccess({
        ...data,
        isAppend: query.isAppend || false,
      })
    })
    .catch(fetchFeedFail);
}

export const fetchQuery = (query) => {
  const {access_token} = localStorage;
  return request.post(`${config.edata.baseUrl}/graphql`)
    .query({
      access_token,
    })
    .send({
      query: `
        query(
          $q: [String]
        ) {
          search(
            q: $q
          ) {
            count
          }
        }
      `,
      variables: query,
    })
    .endAsync()
    .get('body')
    .then(body => {
      if (body.errors) {
        return fetchQueryFail()
      } else {
        return fetchQuerySuccess()
      }
    })
    .catch(fetchQueryFail);
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/tasks.js
 **/